'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryParams = getQueryParams;
exports.getQueryParam = getQueryParam;
function getQueryParams() {
  var result = {};

  if (!window.location || !window.location.search) {
    return result;
  }

  var query = window.location.search.slice(1);
  var parts = query.split('&');

  return parts.reduce(function (resultAcc, part) {
    var xs = part.split('=');
    resultAcc[xs[0]] = xs[1];
    return resultAcc;
  }, result);
}

function getQueryParam(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var params = getQueryParams();
  if (key in params) {
    return params[key];
  }
  return defaultValue;
}


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/location.js
// module id = 2518
// module chunks = 0